import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

/**
 * classNames object that contains responsive bootstrap utility classes for
 * setting the corner radius of an element.
 */
export var getCornerRadiusClasses = function getCornerRadiusClasses(cornerRadiuses) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

  if (!cornerRadiuses) {
    return {};
  }

  return Object.entries(cornerRadiuses).reduce(function (accumulator, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpoint = _ref2[0],
        _ref2$ = _slicedToArray(_ref2[1], 4),
        topStart = _ref2$[0],
        topEnd = _ref2$[1],
        bottomStart = _ref2$[2],
        bottomEnd = _ref2$[3];

    var responsivePrefix = breakpoint === 'xs' ? '' : "-".concat(breakpoint);
    accumulator["rounded-top-start".concat(responsivePrefix, "-").concat(topStart ? size : 0)] = true;
    accumulator["rounded-top-end".concat(responsivePrefix, "-").concat(topEnd ? size : 0)] = true;
    accumulator["rounded-bottom-start".concat(responsivePrefix, "-").concat(bottomStart ? size : 0)] = true;
    accumulator["rounded-bottom-end".concat(responsivePrefix, "-").concat(bottomEnd ? size : 0)] = true;
    return accumulator;
  }, {});
};